
import CanAccessPortal from "@components/Components/Account/AuthLayout/CanAccessPortal";
import dynamic from "next/dynamic";

const LoginPage = dynamic(() => import('../../js/Components/Authentication/Login'), {
    ssr: false,
})

const Login = ({globalProps}) => {
    return (
        <CanAccessPortal>
            <LoginPage/>
        </CanAccessPortal>
    );
};

export async function getServerSideProps(context) {
    return {
      props: {}, // will be passed to the page component as props
    }
}

// // Map redux states to local component props.
// const mapStateToProps = (state) => ({
//     isAuthenticated: state.authReducer.isAuthenticated,
//     // loginError: state.authReducer.loginError,
//     loading: state.authReducer.authLoaders.loginLoading,
// });

// // Define PropTypes.
// Login.propTypes = {
//     props: PropTypes.object,
//     login: PropTypes.func,
// };

// export default connect(mapStateToProps, { login })(Login);

export default Login;